import { wechatOauthLogin } from '@/api/book'
import { getWechatUser, setWechatUser } from '@/utils/auth'

const WECHAT_AUTH_STATE_KEY = 'yes_audio_wechat_auth_state'

export function isWechatBrowser() {
  return /micromessenger/i.test(window.navigator.userAgent)
}

export function getWechatCode(route) {
  if (route && route.query && route.query.code) {
    return route.query.code
  }

  const params = new URLSearchParams(window.location.search)
  return params.get('code')
}

export function buildCleanRedirectUrl() {
  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  return url.toString()
}

export function buildWechatAuthorizeUrl(redirectUrl) {
  const appId = process.env.VUE_APP_WECHAT_APP_ID
  if (!appId) {
    throw new Error('缺少公众号 AppID 配置')
  }

  const state = `${Date.now()}`
  sessionStorage.setItem(WECHAT_AUTH_STATE_KEY, state)

  const params = new URLSearchParams({
    appid: appId,
    redirect_uri: redirectUrl,
    response_type: 'code',
    scope: 'snsapi_base',
    state
  })

  return `https://open.weixin.qq.com/connect/oauth2/authorize?${params.toString()}#wechat_redirect`
}

export async function ensureWechatOpenid(route) {
  const cached = getWechatUser()
  if (cached && cached.openid && cached.token) {
    return cached
  }

  const code = getWechatCode(route)
  if (code) {
    const res = await wechatOauthLogin({
      code,
      redirectUrl: buildCleanRedirectUrl()
    })
    return setWechatUser(res.data)
  }

  if (process.env.NODE_ENV === 'development') {
    const res = await wechatOauthLogin({
      code: 'mock-wechat-code',
      redirectUrl: buildCleanRedirectUrl()
    })
    return setWechatUser(res.data)
  }

  if (!isWechatBrowser()) {
    throw new Error('请在微信内打开页面以获取用户身份')
  }

  window.location.replace(buildWechatAuthorizeUrl(buildCleanRedirectUrl()))
  return new Promise(() => {})
}



// WEBPACK FOOTER //
// ./src/utils/wechat-auth.js